import {
    getTestStory,
    regressionTest,
} from "../../../../test-utils/regression";

describe("ux-scroll-to-top-button", async () => {
    it("passes the regression test", async () => {
        await regressionTest({
            storyId: getTestStory("scroll-to-top-button", "example-with-text"),
            componentTag: "ux-scroll-to-top-button",
            performActions: async (page) => {
                await page.evaluate(() => {
                    window.scrollBy(0, window.innerHeight);
                });
                await page.click(".ux-scroll-to-top-button");
                await new Promise((resolve) => setTimeout(resolve, 1500));
            },
        });
    });
});
